export const Farsi = {
    Confirm: 'تایید',
    SelectAddress: 'انتخاب آدرس',
    AddressDetails: 'پلاک و واحد خود را وارد نمایید',
    AddressNo: 'پلاک',
    AddressUnit: 'واحد',
    SaveAddress: 'این آدرس را برای من ذخیره کن',
    AddressTopic: 'عنوان آدرس',
    IntroSkipLabel: 'شروع',
    IntroNextLabel: 'ورود به برنامه',
    IntroDoneLabel: 'شروع',
    IntroPage1Title: 'پوشش تمام تهران',
    IntroPage2Title: 'شستشو با بهترین کیفیت',
    IntroPage3Title: 'پشتیبانی',
    IntroPage1Text: 'پاکلین لباسهای شما را از هر جای تهران در کمترین زمان دریافت میکند.',
    IntroPage2Text: 'پاکلین با خشکشویی های ممتاز تهران طرف قرارداد می باشد و سفارش های شما با بهترین مواد و تجهیزات شسته میشود.',
    IntroPage3Text: 'پشتیبانی پاکلین از زمان ثبت سفارش تا زمان تحویل به منظور ارایه بهترین خدمات با شما همراه است.',
    LoginTitle: 'ورود',
    LoginEnterPhoneTitle: 'شماره تلفن همراه خود را وارد کنید',
    LoginEnterPhonePlaceHolder: 'شماره تلفن',
    LoginEnterPhoneError: 'شماره تلفن وارد شده نامعتبر است',
    LoginEnterPhoneSequenceTryeText: 'مدت زمان کوتاهی از ارسال رمز ',
    LoginEnterPhoneRequestCode: 'درخواست کد',
    LoginEnterPhoneNotBeginWithZeroError: 'شماره تلفن خود را با صفر وارد کنید.',
    LoginEnterCodeCountTitle: 'کد دریافت شده را وارد کنید.',
    LoginEnterCodeCode: 'کد',
    LoginEnterCodeViaCall: 'دریافت کد از طریق تماس',
    LoginEnterDoNotRcvCode: 'کد را دریافت نکردید؟',
    LoginEnterCodeResend: 'ارسال مجدد',
    MainMenuTitle: 'فهرست',
    MainMenuChargeCredit: 'شارژ حساب کاربری',
    MainMenuItemsProfile: 'حساب کاربری',
    MainMenuItemsMessages: 'پیام ها',
    MainMenuItemsFreeLaundry: 'شستشوی رایگان',
    MainMenuItemsOrderHistory: 'تاریخچه سفارش ها',
    MainMenuItemsPriceEstimator: 'تخمین قیمت',
    MainMenuItemsOffers: 'پیشنهادات ویژه',
    MainMenuItemsAdddressList: 'آدرس های منتخب',
    MainMenuItemsPakleanCollege: 'پاکلین آموز',
    MainMenuItemsSupport: 'پشتیبانی',
    MainMenuItemsNewOrder: 'ثبت سفارش',
    MainMenuFooteText: 'نسخه نرم افزار',
    FreeLaundryTitle: 'شستشوی رایگان',
    FreeLaundryText: 'پاکلین را از طریق کد زیر به دوستان خود معرفی کنید تا در زمان ثبت اولین سفارش نه تنها شما ۷ هزار تومان اعتبار رایگان دریافت کنید بلکه دستان شما نیز ۷ هزار تومان اعتبار اولیه دریافت میکنند.',
    FreeLaundryInviteFriends: 'کد معرفی خود را برای دوستانتان ارسال کنید تا بعد از پایان اولین سفارش آنها به تعداد دوستانی که معرفی شده اند از پاکلین اعتبار 10000 تومانی هدیه بگیرید.',
    FreeLaundryCopy: 'کپی',
    FreeLaundryCopied: 'کپی شد!',
    FreeLaundryShareTitle: 'کد شستشوی رایگان خشکشویی آنلاین پاکلین',
    FreeLaundryShareSubject: 'کد شستشوی رایگان خشکشویی آنلاین پاکلین',
    FreeLaundryShareDesc: 'دوست عزیزم کد زیر برای شستشوی رایگان خشکشویی آنلاین پاکلین هست، با این کد یک سفارش ثبت کن تا هم من و هم خودت از اعتبار هدیه پاکلین استفاده کنیم. ',
    Invite: 'دعوت از دوستان',
    AddressListTitle: 'آدرس های منتخب',
    AddressListEmptyListScreen: 'هنوز آدرس منتخبی ثبت نکرده اید',
    AddressListRemoveAddress: 'حذف',
    ListOfOrdersTitle: 'لیست سفارش ها',
    ListOfOrderDetailsTitle: 'جزییات سفارش',
    NewOrderReview: 'بازبینی و تایید',
    NewOrderResultOk: 'ثبت موفق سفارش',
    NewOrderDetails: 'جزییات سفارش',
    OrderCongratulationText: 'سفارش شما با موفقیت ثبت شد و به زودی از تیم پشتیبانی با شما تماس گرفته میشود',
    OrderCongretulationOrderDetails: 'سفارشتان را پیگیری کنید',
    BackButtonTitle: 'بازگشت',
    ServiceTypeEconomic: 'اقتصادی',
    ServiceTypeVIP: 'فوری - تحویل در همان روز',
    ServiceTypeEconomicPrpA: 'دریافت روز جاری',
    ServiceTypeEconomicPrpB: 'تحویل حداقل ۴۸ ساعت',
    ServiceTypeEconomicPrpC: 'بسته بندی ساده',
    ServiceTypeEconomicFeature: 'ارزان',
    ServiceTypeVipPrpA: 'دریافت روز جاری',
    ServiceTypeVipPrpB: 'تحویل حداقل ۶ ساعت',
    ServiceTypeVipPrpC: 'بسته بندی ویژه',
    ServiceTypeVipFeature: 'قیمت دو برابر',
    OffersTopic: 'پیشنهادات ویژه',
    NewOrderDetailsDeliverAddr: 'آیا آدرس متفاوتی برای تحویل گرفتن دارید؟',
    NewOrderDetailsHaveANyREquest: 'درخواست ویژه ای دارید ؟',
    NewOrderDetailsHaveDiscountCode: 'کد تخفیف دارید ؟ اینجا وارد کنید',
    NewOrderLogiticFeeTopic: 'هزینه حمل و نقل',
    NewOrderMinBasketSizeText: '*در صورتیکه مبلغ سفارش شما بیشتر از --- تومان باشد هزینه ارسال برای سفارش شما رایگان خواهد بود.',
    NewOrderDetailsMoreOffer: 'بیشتر',
    NewOrderDetailsFetchTextPart1: 'انتخاب',
    NewOrderDetailsFetchTextPart2: 'زمان',
    NewOrderDetailsFetchTextPart3: 'دریافت',
    NewOrderDetailsDeliverTextPart1: 'انتخاب',
    NewOrderDetailsDeliverTextPart2: 'زمان',
    NewOrderDetailsDeliverTextPart3: 'تحویل',
    NewOrderDetailsFetchDeliverTopic: 'انتخاب زمان',
    MakeOrder: 'ثبت سفارش',
    FetchTopic: 'دریافت',
    DeliverTopic: 'تحویل',
    ServiceType: 'نوع سرویس',
    EstimatedInvoice: 'پیش فاکتور',
    AnyRequest: 'درخواست های شما',
    DiscountCode: 'کد تخفیف',
    OrderStatus: {
        init: 'در حال تایید',
        cancel: 'لغو شده',
        done: 'تکمیل شده',
        approve: 'در حال دریافت',
        work: 'در حال انجام',
        deliver: 'در حال تحویل',
        doneDebtor: 'بدهکار'
    },
    OrderStatusTopic: 'وضعیت سفارش',
    Currency: 'تومان',
    Cancel: 'لغو',
    NotDeterminedDate: 'مشخص نشده است',
    NotDeterminedRequest: 'درخواستی ثبت نشده است',
    NotDeterminedServiceType: 'سرویس مشخص نشده است',
    NotDeterminedInvoice: 'فاکتور شما بعد از دریافت سفارش صادر میشود',
    NotDeterminedAddress: 'مشخص نشده است',
    NotDeterminedDeliverDate: 'نامشخص',
    ServiceTypes: {
        '1': 'اقتصادی',
        '2': 'ویژه'
    },
    ServiceTypesEn: {
        'economic': 'اقتصادی',
        'vip': 'ویژه'
    },
    ChargeAccountTitle: 'شارژ',
    ChargeAccountConfirm: 'شارژ',
    UserBalance: 'اعتبار شما',
    OnlineCharge: 'شارژ آنلاین',
    CreditCharge: 'شارژ با کد هدیه',
    ChargeAccountGetFee: 'لطفا مبلغ مورد نظر را به تومان وارد نمایید',
    PreDefinedCharge: {
        '10000': '۱۰۰۰۰ تومان',
        '20000': '۲۰۰۰۰ تومان',
        '50000': '۵۰۰۰۰ تومان',
        '100000': '۱۰۰۰۰۰ تومان'
    },
    ChargeAccountEnterCreditCode: 'کد تخفیف را وارد نمایید',
    ProfileScreenTopic: 'حساب کاربری',
    ProfileNameTopic: 'نام',
    ProfileMobileTopic: 'تلفن همراه',
    ProfileEmailTopic: 'پست الکترونیکی',
    ProfilePleaseEnterName: 'نام خود را وارد نمایید',
    ProfilePleaseEnterEMail: 'پست الکترونیکی خود را وارد نمایید',
    ProfilePleaseENterMobile: 'تلفن همراه خود را وارد نمایید',
    TotalInvoiceFee: 'مبلغ قابل پرداخت',
    OrderPayment: 'پرداخت',
    ItemTypes: {
        'Wash-Ironing': 'خشکشویی',
        'Ironing': 'اتو',
        'Wash': 'شستشو',
        'Dyeing': 'رنگ رزی',
        'Stain': 'لکه بری',
        'Sewing': 'خیاطی'
    },
    PaymentInvoiceFee: 'جمع فاکتور',
    PyamentDiscount: 'کد تخفیف',
    PaymentUseCredit: 'استفاده از اعتبار',
    PaymentTotalFee: 'مبلغ قابل پرداخت',
    PaymentUsedDiscountCode: 'مبلغ تخفیف داده شده',
    PaymentDoYouHaveDiscountCode: 'استفاده از کد تخفیف',
    PaymentHasBeenDone: 'پرداخت شده است',
    PaymentTopic: 'پرداخت',
    PaymentUserCredit: 'اعتبار شما',
    PaymentPleaseEnterDiscount: 'لطفا کد تخفیف را وارد نمایید',
    ApplyVoucherCode: 'اعمال کد تخفیف',
    OfferTopic: 'پیشنهادات ویژه',
    CollegeTopic: 'پاکلین آموز',
    CollegeMore: 'بیشتر',
    Services: {
        Washing: 'خشکشویی',
        Ironing: 'اتو',
        Dyeing: 'رنگ رزی',
        Sewing: 'خیاطی',
        Stain: 'لکه بری'
    },
    ErrorMessageTopic: 'توجه',
    ErrorMessages: {
        ServiceNotSupportedInThisRegion: 'این سرویس به زودی در منطقه شما فعال میگردد',
        FetchTImeDoesNotSpecify: 'لطفا زمان دریافت سفارش را مشخص نمایید',
        DeliveryTimeDoesNotSpecify: 'لطفا زمان تحویل سفارش را مشخص نمایید',
        VoucherCodeIsInvalid: 'کد وارد شده نامعتبر است',
        VoucherCodeUsedBefore: 'کد وارد شده قبلا استقاده شده است',
        VoucherCodeExpired: 'تاریخ مصرف کد وارد شده تمام شده است',
        VocherCodePriceConditionFaild: 'مبلغ سفارش شما کمتر از حد مجاز این کد تخفیف است.',
        ErrorInPayment: 'خطایی در پرداخت رخ داده است لطفا دقایقی دیگر مجددا تلاش نمایید',
        OrderCancelError: 'حذف سفارش شما با خطا روبرو گردید',
        AggrementError: 'برای ثبت سفارش باید موافقت خود با قوانین و مقررات پاکلین را اعلام نمایید',
        OrderReviewSubmitError: 'خطا در ثبت نظر، لطفا مجددا تلاش نمایید'
    },
    Messages: {
        VoucherCodeApplied: 'کد اعتبار با موفقیت اعمال گردید',
        OrderCancelSuccessfully: 'سفارش شما با موفقیت حذف گردید',
    },
    ErrorMessageGotIt: 'متوجه شدم',
    NotifMessageTopic: 'پیام پاکلین',
    CancelOrder: 'لغو سفارش',
    OrderCanceld: 'سفارش لغو شده است',
    CancelOrderQuestion: 'آیا از لغو سفارش خود اطمینان دارید‌؟',
    QuestionYes: 'بلی',
    QuestionNo: 'نه',
    DeleteAddressQuestion: 'آیا میخواهید این آدرس را حذف نمایید؟',
    AddressDeleteYes: 'بلی',
    AddressDeleteNo: 'نه',
    AggrementText: 'با قوانین و مقررات پاکلین موافقم.',
    CancelCauseTopic: 'لطفا دلیل لغو سفارش را مشخص نمایید',
    CancelOrderDescription: 'در صورتیکه برای حذف سفارش خود توضیحاتی دارید آن را اینجا بنویسید',
    CancelCauseDescriptionTopic: 'توضیحات',
    CancelOrderTopic: 'لغو سفارش',
    ListOfOrderDetailsPleaseTouch: 'برای مشاهده جزییات لمس کنید',
    OrderReviewWhatIsYourOpinion: 'آیا از سفارش خود از پاکلین راضی بودید؟',
    OrderReviewOK: 'راضی بودم',
    OrderReviewNOK: 'راضی نبودم',
    OrderReviewExtraInfo: 'لطفا دلیل نارضایتی خود را مشخص کنید',
    OrderReviewDescPlaceHolder: 'در صورتیکه توضیحات بیشتر یا پیشنهادی در راستای بهبودی پاکلین دارید اینجا بنویسید',
    OrderReviewDescTopic: 'توضیحات بیشتر',
    OrderReviewSubmitReview: 'ارسال نظر',
    OrderReviewTopic: 'نظرسنجی',
    ChatScreenTitle: 'تماس با پشتیبانی',
    Search: 'جستجو',
    FreeLogisticCost: 'رایگان',
    FetchTime: 'زمان دریافت',
    FetchAndDeliveryTime: 'زمان دریافت و تحویل',
    OrderType: 'نوع سرویس',
    WhichServiceDoYouWant: 'مایل به دریافت کدام نوع سرویس هستید؟',
    WhatsTheDifference: 'تفاوت این دو سرویس در چیست؟',
    RestartAppDueToUpdate: 'اپلیکیشن پاکلین بروزسانی شده است. لطفا آن را بسته و مجددا اجرا نمایید.',
    AddressIsNotComplete: 'آدرسی مشخص نشده است',
    ExitAccount: 'خروج',
    ExitConfirm: 'آیا قصد خروج دارید؟',
    PleaseEnterNoAndUnit: 'لطفا پلاک و واحد خود را مشخص نمایید',
    SelectItems: 'انتخاب اقلام سفارش',
    YourEvaluatedCost: 'هزینه تقریبی فاکتور شما: ',
    CartIsEmpty: 'شما هنوز آیتمی را انتخاب نکرده اید.',
    NoticeThatTheCostIsEvaluated: '*این مبلغ تخمینی است و هزینه ی نهایی پس از دریافت و بررسی، توسط خشکشویی اعلام می گردد.',
    NoticeVIPItemCosts: '*با توجه به فوری بودن سفارش شما قیمت هر یک از اقلام دو برابر محاسبه شده است.',
    OrderItems: 'اقلام سفارش',
    shortId: 'کد کوتاه',
    confirmShortId: 'تایید کد',
    pleaseEnterShortId: 'لطفا ابتدا کد کوتاه را وارد کنید',

    confirmDeliverAddress: 'تایید آدرس ارسال',
    confirmFetchAddress: 'تایید آدرس دریافت',
    shortIdError: 'سفارشی با کد موردنظر وجود ندارد',
    addressChangedSuccessfully: 'آدرس با موفقیت ثبت شد',

    ErrorUpdating: 'خطا در بروزرسانی',

    error: 'خطا',
    CodeIsInCorrect: 'کد وارد شده اشتباه است',
    map: 'تعیین آدرس',
    ordersByRegion: 'آمار سفارش ها بر اساس منطقه',
    showDrivers: 'موقعیت راننده ها',
    damages: 'خسارات',
    customerLoyalty: 'وفاداری مشتری',

    firstOrderDate: 'تاریخ اولین سفارش',
    lastOrderDate: 'تاریخ آخرین سفارش',
    orderFrequency: 'فرکانس',
    totalItems: 'مجموع اقلام',
    orderCount: 'تعداد سفارش ها',
    totalCart: 'مجموع سبد خرید',
    totalDiscount: 'مجموع تخفیف ها',
    totalRevenue: 'مجموع درآمد شرکت',
    timePassedFromRegisteration: 'مدت گذشته از عضویت',
    timePassedFromFirstOrderToRegister: ' مدت بین عضویت و اولین سفارش',
    timePassedFromLastOrder: 'مدت گذشته از آخرین سفارش',
    phoneNumber:'شماره تلفن',
    


    LocationPermissionDenied: 'لطفا دسترسی به لوکیشن را فعال کنید',
    LocationUnavailable: 'لطفا لوکیشن دستگاه را بررسی نمایید',
    LocationTimeout: 'The request to get user location timed out',
    LocationUnknownError: 'An unknown error occurred',
    NoGelolocation: 'عدم دسترسی به لوکیشن'
}